module.exports = __webpack_public_path__ + "static/media/Adobe_Corporate_White.2a2b1cab.svg";